import type { Compare } from "@suse-o11y/compare";

export function isArrayEqual<T>(left: ArrayLike<T>, right: ArrayLike<T>, isEqual: Compare<T>): boolean {
	if (left === right) {
		return true;
	}

	if (left.length !== right.length) {
		return false;
	}

	for (let index = 0; index < left.length; index++) {
		if (!isEqual(left[index], right[index])) {
			return false;
		}
	}

	return true;
}
